var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-dlg',{ref:"modal",attrs:{"id":"modal","title":"Remove installation","submit":_vm.removeInstall,"validator":_vm.$validator,"no-fade":"","lazy":"","ok-variant":"danger","ok-title":"Remove"},on:{"cancel":_vm.clearState,"hidden":_vm.clearState}},[_vm._v(" Are you sure you want to delete the install? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }